import { Injectable, inject, signal } from '@angular/core';
import { filter } from 'rxjs/operators';
import { DayOrWeekCalendarModel } from '../../../core/models/calendar/day-or-week-calendar.model';
import { TimeCoordinateMappingService } from '../time-mapping/time-coordinate-mapping.service';
import { DateTimeHelper } from '../util/date-time-helper';
import { CalendarService } from './calendar.service';

@Injectable()
export class CalendarDayOrWeekViewService {
  // Signals
  public businessTimeTop = signal(-1);
  public businessTimeHeight = signal(-1);

  public calendarService = inject(CalendarService);
  public timeCoordinateMapperService = inject(TimeCoordinateMappingService);

  public calcBusinessTimeAreas(): void {
    this.timeCoordinateMapperService.pixelsPerMinuteCalculated$
      .pipe(filter((ppm) => !!ppm))
      .subscribe(() => {
        const model = this.calendarService.model as DayOrWeekCalendarModel;
        const workTimeStart = model.calendarProperties.workTimeStart;
        const workTimeEnd = model.calendarProperties.workTimeEnd;

        const top = this.timeCoordinateMapperService.mapDurationToScreenLength(
          DateTimeHelper.startOfToday(),
          workTimeStart,
        );
        const height = this.timeCoordinateMapperService.mapDurationToScreenLength(
          workTimeStart,
          workTimeEnd,
        );

        this.businessTimeTop.set(top);
        this.businessTimeHeight.set(height);
      });
  }
}
